import { FC, useCallback, useRef, useState } from "react"
import { Modal } from "../../features/Modal/Modal"
import writeXlsxFile from "write-excel-file"
import { ISupply } from "../../app/reducers/ordersReducer"
import { saveAuditFormOrderWB } from "../../utils/auditFormOrder"
import { SHOP_NAME } from "@acc/shared"
import { Button } from "@radix-ui/themes"
import { DataTable, type DataTableColumn } from "../DataTable/DataTable"

export type RecodeKatrenItem = {
  GoodName: string
  GoodCode: string
  nmId: number
  sku: string
  count: number
  commission: number
}

export type RecodeKatren = RecodeKatrenItem[]

export type IRecodeOzonKatrenItem = {
  name: string
  offer_id: string
  product_id: number
  count: number
}

export type IRecodeOzonKatren = IRecodeOzonKatrenItem[]

type FormKatrenOrderProps = {
  isDisabled?: boolean
  getOrdersForKatren: () => Promise<{
    recodeForOrderkatren: RecodeForOrderkatren[]
    missOrders: MissOrderkatren[]
    info?: {
      name: string
      value: string
      count: number
      date: string
    }[]
  }>
  name?: string
  supplies?: ISupply[]
}

export type RecodeForOrderkatren = {
  GoodName: string
  GoodCode: string
  Quantity: number
}

export type MissOrderkatren = {
  GoodCode: string
  nmId: number
}

const RECODE_FOR_ORDER_SCHEMA = [
  {
    column: "GoodName",
    value: (item: RecodeForOrderkatren) => item.GoodName,
  },
  {
    column: "GoodCode",
    value: (item: RecodeForOrderkatren) => item.GoodCode,
  },
  {
    column: "Quantity",
    value: (item: RecodeForOrderkatren) => item.Quantity,
  },
]

const downloadRecode = (data: RecodeForOrderkatren[], fileName?: string) => {
  return writeXlsxFile(data, {
    schema: RECODE_FOR_ORDER_SCHEMA,
    fileName: (fileName && fileName + ".xlsx") || "order_import.xlsx",
  })
}

export const FormKatrenOrder: FC<FormKatrenOrderProps> = ({
  isDisabled,
  getOrdersForKatren,
  name = "Сформировать файл для заказа Katren",
  supplies,
}) => {
  const [isOpenModalFormOrders, setIsOpenModalFormOrders] = useState(false)
  const missOrdersRef = useRef<MissOrderkatren[]>([])
  const orderskatrenRef = useRef<RecodeForOrderkatren[]>([])
  const infoRef = useRef<
    {
      name: string
      value: string
      count: number
      date: string
    }[]
  >([])
  const fileName = supplies?.map((supply) => supply.name).join(", ")

  const onClickFormOrderKatren = useCallback(() => {
    getOrdersForKatren().then(({ recodeForOrderkatren, missOrders, info }) => {
      missOrdersRef.current = missOrders || []
      orderskatrenRef.current = recodeForOrderkatren || []
      infoRef.current = info || []
      setIsOpenModalFormOrders(true)
    })
  }, [getOrdersForKatren])

  return (
    <div>
      <Button disabled={isDisabled} onClick={onClickFormOrderKatren}>
        {name}
      </Button>

      <Modal
        isOpen={isOpenModalFormOrders}
        onClose={() => {
          setIsOpenModalFormOrders(false)
        }}
        header={"Сформированный файл для заказа Katren"}
        onOk={() => {
          downloadRecode(orderskatrenRef.current, fileName).then((res) => {
            saveAuditFormOrderWB(SHOP_NAME.KATREN, supplies || [])
          })
        }}
        content={
          <ModalOrderList
            orderskatren={orderskatrenRef.current}
            missOrderkatren={missOrdersRef.current}
            info={infoRef.current || []}
          />
        }
        size="l"
        okContent="Скачать"
      />
    </div>
  )
}

type ModalOrderListProps = {
  orderskatren: RecodeForOrderkatren[]
  missOrderkatren: MissOrderkatren[]
  info: {
    name: string
    value: string
    count: number
    date: string
  }[]
}
export const ModalOrderList = ({
  missOrderkatren,
  info,
}: ModalOrderListProps) => {
  const katrenColumns: DataTableColumn<MissOrderkatren>[] = [
    { key: "GoodCode", header: "Артикул продавца" },
    { key: "nmId", header: "Артикул WB" },
  ]

  return (
    <div>
      {(info?.length && (
        <div style={{ backgroundColor: "var(--colors-warning300)" }}>
          <b>Для следующих поставок уже был сформирован заказ:</b>
          <ol>
            {info.map((item) => (
              <li key={item?.value}>
                <b>{item?.name}</b>, {item?.count} раз(а),{" "}
                {new Date(item?.date).toLocaleString()}
              </li>
            ))}
          </ol>
        </div>
      )) ||
        null}
      <label>Артикулы, которые не найдены в перекодировке</label>
      <DataTable
        columns={katrenColumns}
        data={missOrderkatren ?? []}
        rowKey={(_el, i) => "order-list-" + i}
      />
    </div>
  )
}
